import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/lib/utils';

/**
 * PART 9's four screens, in the order §9.1 asks the questions:
 *
 *   What goes into what?              MFG-01 Bills of Materials
 *   What should we make next?         MFG-03 Production Planning
 *   Make this batch.                  MFG-02 Work Orders
 *   What did we actually use?         MFG-04 Material Consumption
 *
 * The menu keeps the prototype's own order (BOM, Work Orders, Planning,
 * Consumption); the reading order above is why the four belong together.
 *
 * ONE gate sits above these tabs and it is not drawn here: the manufacturing
 * paid module (§9.1.2). A company without it never reaches this component,
 * because the whole group is absent from the menu. *Changed by owner ruling
 * R1: there is no second gate — no view mode, no simplified layouts.*
 */
const TABS = [
  { to: '/manufacturing', end: true, key: 'mfg.tabBoms' },
  { to: '/manufacturing/work-orders', end: false, key: 'mfg.tabWorkOrders' },
  { to: '/manufacturing/planning', end: false, key: 'mfg.tabPlanning' },
  { to: '/manufacturing/consumption', end: false, key: 'mfg.tabConsumption' },
] as const;

export function ManufacturingTabs() {
  const { t } = useTranslation();
  return (
    <nav className="flex flex-wrap gap-1 border-b pb-px" aria-label={t('shell.navManufacturing')}>
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'rounded-t-md px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground',
              isActive && 'border-b-2 border-primary text-foreground',
            )
          }
        >
          {t(tab.key)}
        </NavLink>
      ))}
    </nav>
  );
}
